import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { cvData } from '../mock';
import { Button } from '../components/ui/button';

const Contact = () => {
  return (
    <div className="min-h-screen bg-off-white py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Get In Touch
          </h1>
          <p className="text-lg text-neutral-700">
            Interested in collaboration, exhibitions, or learning more about my work?
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Contact Info Card */}
          <div className="bg-charcoal text-off-white p-8 rounded-lg">
            <h2 className="text-2xl font-bold mb-6">Contact Information</h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <Phone className="h-6 w-6 text-copper mr-4 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold mb-1">Phone</p>
                  <a href={`tel:${cvData.contact.phone}`} className="text-warm-grey hover:text-copper transition-colors">
                    {cvData.contact.phone}
                  </a>
                </div>
              </div>
              <div className="flex items-start">
                <Mail className="h-6 w-6 text-copper mr-4 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold mb-1">Email</p>
                  <div className="space-y-1">
                    {cvData.contact.email.map((email, index) => (
                      <a
                        key={index}
                        href={`mailto:${email}`}
                        className="block text-warm-grey hover:text-copper transition-colors"
                      >
                        {email}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links Card */}
          <div className="bg-warm-grey p-8 rounded-lg">
            <h2 className="text-2xl font-bold text-charcoal mb-6">Quick Links</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-charcoal mb-2">Current Affiliations</h3>
                <ul className="space-y-2 text-neutral-700">
                  <li>
                    <a href="https://filsonhistorical.org" target="_blank" rel="noopener noreferrer" className="hover:text-copper transition-colors">
                      Filson Historical Society
                    </a>
                  </li>
                  <li>
                    <a href="https://kycad.org" target="_blank" rel="noopener noreferrer" className="hover:text-copper transition-colors">
                      Kentucky College of Art + Design
                    </a>
                  </li>
                  <li>
                    <a href="https://roots101museum.org" target="_blank" rel="noopener noreferrer" className="hover:text-copper transition-colors">
                      Roots 101 African American Museum
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Opportunities */}
        <div className="mt-12 bg-copper/10 border-l-4 border-copper p-8 rounded">
          <h3 className="text-xl font-bold text-charcoal mb-4">Open to Opportunities</h3>
          <p className="text-neutral-700 mb-6">
            I am available for collaborations, exhibitions, curatorial projects, and speaking engagements. 
            My practice explores ADOS identity, Wake Work, and interdisciplinary approaches merging technology, the body, and the environment.
          </p>
          <div className="flex flex-wrap gap-4">
            <a href={`mailto:${cvData.contact.email[0]}`}>
              <Button className="bg-charcoal hover:bg-charcoal/90 text-off-white">
                Send Email
                <Mail className="ml-2 h-4 w-4" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;